module.exports = __webpack_public_path__ + "static/customer_photo_5-b1fd6e43ec80ecef6e58de8426c8b518.jpg";